import { Field, FieldError, FieldLabel, RadioGroup } from "@/components/ui";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";

import {
  type AOEAnswerCoding,
  type AOEQuestion,
  AOEQuestionAnswerType,
  isAOEAnswerCoding,
} from "../../../network/useRetrieveAOEForOrder";
import type { AOEFormSchema } from "../schemas";

export const RadioQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  const value = field.value as AOEAnswerCoding | string | undefined;
  const options =
    question.answerOptions?.map((option) => ({
      value: option.valueCoding?.code ?? option.valueString ?? "",
      label: option.valueCoding?.display ?? option.valueString ?? "",
      answerType: option.valueCoding
        ? AOEQuestionAnswerType.CODING
        : AOEQuestionAnswerType.TEXT,
    })) ?? [];

  const handleValueChange = (code: string) => {
    const option = options.find((option) => option.value === code);
    if (option?.answerType === AOEQuestionAnswerType.CODING) {
      field.onChange({
        code,
        display: option.label,
      });
    } else {
      field.onChange(code);
    }
  };

  return (
    <Field data-invalid={fieldState.invalid}>
      <FieldLabel htmlFor={field.name}>
        {question.required && "*"}
        {question.question}
      </FieldLabel>
      <RadioGroup
        id={field.name}
        value={isAOEAnswerCoding(value) ? value.code : (value ?? "")}
        onValueChange={handleValueChange}
        options={options}
        disabled={disabled}
        aria-invalid={fieldState.invalid}
      />
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
